module.exports = __webpack_public_path__ + "img/portrait-054.608cbc18.jpg";